import {
    ASK_FOR_HELP_BUTTON,
    CONNECT_USER_OPTION,
    FREE_AMOUNT_ON_PRODUCT,
    FREE_PRODUCT,
    FULL__BASKET_ICON_ROLE,
    INVALID_TOTAL_PRICE_PROBLEM,
    PERCENT_ON_PRODUCT,
    PRM_BUTTON,
    USUAL_MODE,
} from "@constants";
import { useSnapshot } from "valtio";

import React from "react";
import { shallowEqual, useSelector } from "react-redux";

import { setIsTechProblemModalOpened } from "@store";

import { getImageContentById, getSkippedStepNumber } from "@helpers/general";

import { getOrdertakingOptions } from "@components/OrderTaking/Helpers";
import { isTotalPriceValid } from "@components/OrderTaking/Helpers/TotalPriceValid";
import { memoizedOrderItems } from "@components/OrderTaking/Store/feature";

import {
    kioskStore,
    setAuthModalStepIndex,
    setIsHelpModalOpened,
    setIsInformationModeActivated,
    setIsOrderTakingPreviousStep,
    setIsPrm,
    setIsUserAccountModalOpened,
    setLeftToPay,
    setNavigationIndex,
    setOrderTotalPrice,
} from "@pages/Kiosk/store";

export default function useOrderSummary(
    open,
    setIsSummaryOrderOpened,
    setIsOrderAlert
) {
    const orderItems = useSelector((state) => memoizedOrderItems(state));
    const {
        order: { totalPrice, itemsCount },
    } = useSelector((state) => state.orderSlice, shallowEqual);
    const usedGifts = useSelector(
        (state) => state.orderSlice.usedGifts,
        shallowEqual
    );

    const {
        kioskWays,
        selectedSaleModeValue,
        project,
        isPrm,
        navigationIndex,
        isAuthenticationAccepted,
        isUserAuthenticated,
        selectedInformationMode,
        isOrderPaidWithLoyaltyAccountBalance,
        selectedRegulationModeValue,
        project: {
            fidelityType,
            template: {
                content,
                pages: {
                    ways: { informationModes },
                },
            },
            files: images,
        },
        customerLanguage,
        activeConfigOptions,
        isInformationModesModalOpened,
        isInformationModesConsommationModalOpened,
        isConfirmationModalOpened,
        paymentModes,
        isClickAndCollect,
        devise,
    } = useSnapshot(kioskStore);

    const {
        isSummaryLogoActive,
        IsAccumulatedLoyaltyPointsActive,
        summaryHeaderMessage,
        isSalesMethodsChangeActive,
        summaryActionsButtons,
        isSummaryOptionsItemsActive,
        summaryOptionsItems,
        isSummaryBackgroundActive,
    } = useSelector((state) => state.settingSlice.summary, shallowEqual);

    const { designItems } = useSelector((state) => state.settingSlice);

    const { isCommentKeyboardActive } = useSelector(
        (state) => state.orderSlice,
        shallowEqual
    );
    const filledBasketIcon = designItems.filter((item) => {
        return item.role === FULL__BASKET_ICON_ROLE;
    });
    const filledBasketIconContent =
        filledBasketIcon.length > 0
            ? getImageContentById(filledBasketIcon[0].id)
            : "";

    const loyaltyCardItem =
        project.template.content.authenticationModes.items.filter((item) => {
            return item.name === "Loyalty card" && item.active === true;
        })[0];

    const newActiveOptions = isPrm
        ? activeConfigOptions.filter(
              (config) => config.title.toLowerCase() !== PRM_BUTTON
          )
        : activeConfigOptions.filter(
              (config) => config.title.toLowerCase() !== USUAL_MODE
          );

    const newOptionConfig = getOrdertakingOptions(
        newActiveOptions,
        summaryOptionsItems
    );

    const backgroundImage = Object.values(images).find((image) => {
        return (
            image.key === "background" && image.name === "orderTakingSummary"
        );
    });
    const imageSrc = getImageContentById(backgroundImage.id);

    const DisplayedOrderPrice = `${totalPrice.toFixed(devise.decimalPrice)} ${
        devise.deviseSymbole
    }`;

    async function handleCartChangedCLickEvent() {
        const localPaymentAmount = paymentModes
            ?.filter((mode) => mode.paymentMode !== "loyalty")
            .reduce((acc, curr) => acc + Number(curr.paymentAmount), 0);
        console.log({ localPaymentAmount });
        setLeftToPay(totalPrice - localPaymentAmount);

        // Check if the information mode is active for the current category or all categories
        const isInformationModeActivePerCategory =
            informationModes?.isInformationModeActivePerCategory ?? false;
        setIsInformationModeActivated(!isInformationModeActivePerCategory);
        if (isInformationModeActivePerCategory) {
            const isOrderItemsHaveInformationModeActive = orderItems.some(
                (item) => item.isInformationModeActivated === true
            );
            setIsInformationModeActivated(
                isOrderItemsHaveInformationModeActive
            );
        }

        setOrderTotalPrice(totalPrice - localPaymentAmount);
        const totalPriceValid = isTotalPriceValid(
            orderItems,
            totalPrice,
            usedGifts
        );
        if (!totalPriceValid) {
            console.log(
                "Total price is not valid on handleCartChangedCLickEvent",
                {
                    orderItems,
                    totalPrice,
                    usedGifts,
                }
            );
            setIsTechProblemModalOpened(true, INVALID_TOTAL_PRICE_PROBLEM);
            return;
        }
        setNavigationIndex(
            navigationIndex +
                Number(
                    await getSkippedStepNumber(
                        kioskWays,
                        navigationIndex,
                        isAuthenticationAccepted,
                        isUserAuthenticated,
                        selectedSaleModeValue,
                        selectedInformationMode,
                        isOrderPaidWithLoyaltyAccountBalance,
                        selectedRegulationModeValue,
                        content,
                        Number(totalPrice)
                    )
                )
        );

        setIsOrderTakingPreviousStep(true);
    }

    function handleConfigOptionOnClickEvent(option) {
        switch (option.title.toLowerCase()) {
            case PRM_BUTTON:
                setIsPrm(!isPrm);
                break;
            case USUAL_MODE:
                setIsPrm(!isPrm);
                break;
            case ASK_FOR_HELP_BUTTON:
                setIsHelpModalOpened(true);
                break;
            case CONNECT_USER_OPTION:
                if (isUserAuthenticated === false) {
                    setIsUserAccountModalOpened(true),
                        setAuthModalStepIndex(navigationIndex);
                }
                break;

            default:
                null;
        }
    }

    function CheckUnusedCodePromo() {
        const isUsedCodePromo = orderItems.some(
            (order) => order.discountedPrice
        );
        const promoType = [
            FREE_AMOUNT_ON_PRODUCT,
            PERCENT_ON_PRODUCT,
            FREE_PRODUCT,
        ];
        const isPromoProduct = usedGifts.some((promo) =>
            promoType.includes(parseFloat(promo.discountType))
        );
        if (!isUsedCodePromo && isPromoProduct) {
            setIsOrderAlert(true);
            return;
        }
        handleCartChangedCLickEvent();
    }

    React.useEffect(() => {
        if (open === true && orderItems.length === 0) {
            setIsSummaryOrderOpened(false);
        }
    }, [orderItems]);
    return {
        newOptionConfig,
        imageSrc,
        DisplayedOrderPrice,
        handleConfigOptionOnClickEvent,
        CheckUnusedCodePromo,
        loyaltyCardItem,
        filledBasketIconContent,
        isCommentKeyboardActive,
        fidelityType,
        itemsCount,
        handleCartChangedCLickEvent,
        isInformationModesModalOpened,
        isPrm,
        isInformationModesConsommationModalOpened,
        isConfirmationModalOpened,
        isSummaryBackgroundActive,
        isSummaryLogoActive,
        IsAccumulatedLoyaltyPointsActive,
        customerLanguage,
        usedGifts,
        summaryHeaderMessage,
        orderItems,
        isSalesMethodsChangeActive,
        isClickAndCollect,
        isSummaryOptionsItemsActive,
        summaryActionsButtons,
    };
}
